export default __webpack_public_path__ + "pdf-viewer/web/viewer.html";